import { render, staticRenderFns } from "./AssetDetailDialog.vue?vue&type=template&id=45c22eaf&scoped=true"
import script from "./AssetDetailDialog.vue?vue&type=script&lang=js"
export * from "./AssetDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AssetDetailDialog.vue?vue&type=style&index=0&id=45c22eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c22eaf",
  null
  
)

export default component.exports